import React from 'react'
import ReactDOM from 'react-dom/client'

/* CSS */
import './design/css/app.css'
import './design/css/content.css'
import './design/css/preloader.css'
import './design/css/roulettetable.css'
import './design/css/chips.css'
import './design/css/rates.css'
import './design/css/result.css'
import './design/css/special.css'
import './design/css/lastnumbers.css'
import './design/css/statistics.css'
import './design/css/return.css'
import './design/css/gamebottommodal.css'
import './design/css/logo.css'

import App from './App'
import reportWebVitals from './reportWebVitals'

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(token.length > 64 ? <App /> : <div className="page-404"><span>404</span> Page not found</div>)

reportWebVitals()